<!-- 车位信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportCarport",
                "parkCode": "2KNVSH0M",
                "isDeleted":false,
                "carportList": [
                    {
                        "carportType": 0,
                        "carportAlaisName": "001",
                        "carportSerialNumber": "001",
                        "parkingLotId": "2KNVSH0M",
                        "isOpenReserved": false
                    }
                ],
                "reportTime": "20170929084043"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车位信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportCarport",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间，yyyyMMddHHmmss' },
                        { info1: 'isDeleted', info2: '是', info3: 'boolean', info4: '是否删除，如果true,则表示下面的车位list都是属于删除的' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'carportList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'carportList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingLotId', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carportSerialNumber', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'carportAlaisName', info2: '是', info3: 'String', info4: '车位别名' },
                        { info1: 'carportType', info2: '是', info3: 'int', info4: '车位类型：0未指定,1固定车位,2临时车位,3租用车位' },
                        { info1: 'isOpenReserved', info2: '是', info3: 'boolean', info4: '是否开启预订：0否，1是' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportCarport.vue